// B0 (2d-iii Fas 0, fynd iv) — the /play join-confirm "Gå med" gate, pure for unit testing.
//
// Mirrors the detail page's joinReady (ActivityActions): a system-mode join must NEVER be
// clickable before its charge breakdown has resolved. While the breakdown query loads,
// confirmWillCharge reads false (undefined → 0) and the 4.3 card gate would let a no-card
// join slip through — creating an orphaned pending with no charge. L56 distinction:
// null/undefined = still loading ≠ 0 = genuinely free (court-less/zero charge joins stay open).
export function isJoinConfirmDisabled(args: {
  isPending: boolean;
  paymentMode: string | null | undefined;
  /** The canonical breakdown's totalMinor, or null/undefined while the query is loading. */
  totalMinor: number | null | undefined;
  hasMitCard: boolean;
}): boolean {
  const { isPending, paymentMode, totalMinor, hasMitCard } = args;
  if (isPending) return true;
  // System-mode: wait for the charge to be known (loading → disabled).
  if (paymentMode === "system" && totalMinor == null) return true;
  // 4.3 card gate: a join that will charge requires a saved MIT card.
  return (totalMinor ?? 0) > 0 && !hasMitCard;
}
